// extracted by mini-css-extract-plugin
export var colorSquare = "_ti-0";
export var danger = "_ti-5";
export var lightPink = "_ti-8";
export var neutralBlue = "_ti-7";
export var neutralYellow = "_ti-6";
export var normal = "_ti-1";
export var primary = "_ti-2";
export var primaryLight = "_ti-3";
export var solidBlack = "_ti-g";
export var solidGreen = "_ti-b";
export var solidLightBlue = "_ti-d";
export var solidNavy = "_ti-c";
export var solidOrange = "_ti-f";
export var solidPink = "_ti-e";
export var solidRed = "_ti-9";
export var solidYellow = "_ti-a";
export var success = "_ti-4";